import QuestionModel from './question-model';
import Storage from "../storage";
import ShuffleAnimation from "../shuffle-animation";
import Api from "../../../../lib/api";

export default class MainController {
	constructor($root, isMultiple, isFirstSession, courseId) {
		this.$root = $root;
		this.config = null;
		this.otherQuizConfig = null;
		this.getUrl = null;
		this.postUrl = `${Api.restSiteUrl}/2.0/courses/registration`;

		this.storage = new Storage(courseId);
		this.animation = new ShuffleAnimation($root);

		this.isMultiple = isMultiple;
		this.isFirstSession = isFirstSession;
		this.isOtherQuizResult = false;

		this.events = {};

		this.questionModels = null;
		this.currentQuestion = null;
		this.totalCorrect = 0;
		this.isPreLastQuestion = false;
		this.isLastQuestion = false;
		this.isFirstQuestion = false;
	}

	get isFinished() {
		const data = this.storage.getLocalStorage();

		return data['special-event-quiz'] && data['special-event-quiz'].result;
	}

	init(callback, config) {
		this.config = config;
		this.getUrl = `${craft.env.apiSiteUrl}/feed/quiz?entryId=${config.entryId}`;
		this.getOtherQuizConfig();
		this.checkForOtherQuizResult();

		const isStorage = this.storage.init('special-event-quiz');

		if (isStorage) {
			this.setQuestionConfig(this.storage.questionList);
			// this.writeTitles();
			callback(this.storage);
		} else {
			this.fetchFromServer(callback);
		}
	}

	fetchFromServer(callback) {
		Api.get(this.getUrl).then(data => {
			this.storage.setData(
				data.title,
				data.icon,
				data.description,
				data.passGrade,
				data.totalQuestions,
				data.questions,
				0
			);
			this.setQuestionConfig(data.questions);
			this.saveInitialData();
			// this.writeTitles();
			callback(false); /* Callback param -> isStorage: bool || string */
		});
	}

	saveInitialData() {
		this.storage.update(this.currentQuestion.getResultObj());
	}

	writeTitles() {
		const title = this.storage.quizTitle;

		setTimeout(() => {
			this.$root.querySelectorAll('.quiz_title').forEach(($item) => {
				$item.textContent = title;
			});
		}, 50);
	}

	getOtherQuizResult() {
		const storageData = this.storage.getLocalStorage();
		const otherQuizEntryId = this.otherQuizConfig ? this.otherQuizConfig.entryId : null;
		if (
			otherQuizEntryId &&
			storageData &&
			storageData.hasOwnProperty(otherQuizEntryId) &&
			storageData[otherQuizEntryId].hasOwnProperty('result')
		) {
			return storageData[otherQuizEntryId]['result'];
		}
		return null;
	}

	checkForOtherQuizResult() {
		this.isOtherQuizResult = !!this.getOtherQuizResult();
	}

	setQuestionConfig(questionList) {
		this.setQuestionModels(questionList);
		this.currentQuestion = this.getCurrentQuestion();
		this.checkLimits();
	}

	setQuestionModels(questionList) {
		/* The method instantiates data models for questions */

		this.questionModels = questionList.map((item, i) => {
			item.index = i;
			return QuestionModel.getInstance(item);
		});
	}

	getCurrentQuestion() {
		return this.questionModels[this.storage.currentQuestionIndex];
	}

	checkLimits() {
		this.isPreLastQuestion = this.storage.currentQuestionIndex === this.storage.totalQuestions - 2;
		this.isLastQuestion = this.storage.currentQuestionIndex === this.storage.totalQuestions - 1;
		this.isFirstQuestion = this.storage.currentQuestionIndex === 0;
	}

	getCurrentIndex() {
		return this.storage.currentQuestionIndex;
	}

	getTotalQuestions() {
		return this.storage.totalQuestions;
	}

	updateState(isNext) {
		if (isNext) {
			this.storage.indexUp();
		} else {
			this.storage.indexDown();
		}
		this.checkLimits();
	}

	saveAnswer(answerList = null) {
		const currentQuestion = this.getCurrentQuestion();
		const isAnswered = !!currentQuestion.answered;

		if (!isAnswered || (isAnswered && (JSON.stringify(answerList) !== JSON.stringify(currentQuestion.answered)))) {
			currentQuestion.setAnswer(answerList);
			this.storage.update(currentQuestion.getResultObj());
		}
	}

	getUserData() {
		return this.storage.getUserData();
	}

	getResult() {
		this.storage.ratio = this.countRatio();
		return this.storage.getFilteredData();
	}

	getResultGrade() {
		let resultGrade = this.storage.getResultGrade();
		if (!resultGrade) {
			resultGrade = null;
			console.error('Result grade is not defined!');
		}
		return resultGrade;
	}

	countRatio() {
		this.totalCorrect = this.questionModels.reduce((acc, cur) => {
			return acc + cur.isAnswerCorrect;
		}, 0);
		return `${this.totalCorrect}/${this.storage.totalQuestions}`;
	}

	finishQuiz(userData = null) {
		this.storage.saveResult();
		if (userData !== null) {
			this.storage.saveUserData(userData);
		}
	}

	getOtherQuizConfig() {
		const currentEntryId = this.config.entryId;
		const indexOfCurrentItem = craft.page.specialEventConfig.items.findIndex(item => item.entryId === currentEntryId);
		const itemList = craft.page.specialEventConfig.items.slice();
		itemList.splice(indexOfCurrentItem, 1);
		if (itemList.length) {
			this.otherQuizConfig = itemList[0];
		}
	}

	getQuizTitle() {
		return this.storage.quizTitle;
	}

	setAnimationState() {
		if (this.storage.getUserData()) {
			if (this.isPreLastQuestion) {
				this.animation.setPreLastPageState();
			} else if (this.isLastQuestion) {
				this.animation.setLastPageState();
			} else {
				this.animation.setDefaultState();
			}
		}
	}

	toggleProgressOverlay(type) {
		const $greetingPage = this.$root.querySelector('.quiz-page.-initial');

		if ($greetingPage) {
			if (type === 'show') {
				$greetingPage.classList.add('-progress');
			} else if (type === 'hide') {
				$greetingPage.classList.remove('-progress');
			}
		}
	}

	registerEvent(name, eventType = null, $elem = null, handler = null) {
		if (!this.events.hasOwnProperty(name)) {
			this.events[name] = {
				type: eventType,
				$elem: $elem,
				handler: e => {
					if (document.body.classList.contains('-modal')) {
						handler(e);
					}
				},
				registered: false
			}
		}

		if (!this.events[name].registered) {
			this.events[name].$elem.addEventListener(this.events[name].type, this.events[name].handler);
			this.events[name].registered = true;
		}
	}

	unregisterEvent(name) {
		if (this.events.hasOwnProperty(name)) {
			this.events[name].$elem.removeEventListener(this.events[name].type, this.events[name].handler);
			this.events[name].registered = false;
		}
	}
}